import addNewStudentTemplate from './add-new-student/add-new-student.html';
import registrationWithCardTemplate from './registration-with-card/registration-with-card.html';
import deregistrationWithCardTemplate from './deregistration-with-card/deregistration-with-card.html';

export default dashboardConfig;

/** @ngInject */
function dashboardConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Tablica',
    state: 'modules.dashboard',
    showInMenu: true,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.dashboard', {
      url: '/dashboard',
      views: {
        'content@': {
          component: 'dashboardComponent'
        }
      },
      resolve: {
        access: (AccessService, me, $q) => {
          if (me.roleName !== 'MANAGER') {
            return $q.resolve(AccessService.getEmployeeAccess(me.generalAccesses));
          }

          return AccessService.get(me.employeeId);
        },
        currentClassRoom: ClassRoomService => ClassRoomService.getCurrentClassRoom(),
        classRooms: ($log, ClassRoomService) => {
          return ClassRoomService.getClassRooms();
        },
        tags: TagService => TagService.list()
      },
      onEnter: ($state, access, currentSchoolCommonRoom) => {
        if (!currentSchoolCommonRoom.configurationCompleted) {
          return $state.target('schoolCommonRoom.select');
        }
      }
    })
    .state('modules.dashboard.addNewStudent', {
      url: '/addNewStudent',
      onEnter: [
        '$log',
        '$rootScope',
        '$q',
        '$mdDialog',
        '$state',
        'SchoolClassService',
        'GroupService',
        'AccessService',
        ($log, $rootScope, $q, $mdDialog, $state, SchoolClassService, GroupService) => {
          $mdDialog.show({
            bindToController: true,
            controllerAs: 'ctrl',
            controller: 'AddNewStudentController',
            template: addNewStudentTemplate,
            disableParentScroll: true,
            clickOutsideToClose: true,
            resolve: {
              schoolClasses: () => {
                return SchoolClassService.getSchoolClass();
              },
              groups: () => {
                return GroupService.getAllGroups();
              },
              currentClassRoom: ClassRoomService => {
                return ClassRoomService.getCurrentClassRoom();
              },
              access: AccessService => {
                if ($rootScope.me.roleName !== 'MANAGER') {
                  return $q.resolve(AccessService.getEmployeeAccess($rootScope.me.generalAccesses));
                }

                return AccessService.get($rootScope.me.employeeId);
              },
              classRooms: ClassRoomService => {
                return ClassRoomService.getClassRooms();
              }
            }
          })
            .then(() => {
              $state.go('modules.dashboard');
            }, err => {
              if (angular.isUndefined(err) || err.Status !== 403) {
                $state.go('modules.dashboard');
              }
            });
        }
      ]
    })
    .state('modules.dashboard.registerWithCard', {
      url: '/registerWithCard',
      onEnter: [
        '$mdDialog',
        '$state',
        '$rootScope',
        '$q',
        'currentClassRoom',
        'access',
        'classRooms',
        'ProximityCardService',
        'StudentService',
        ($mdDialog, $state, $rootScope, $q, currentClassRoom, access, classRooms, ProximityCardService, StudentService) => {
          $mdDialog.show({
            clickOutsideToClose: true,
            controller: 'RegistrationWithCardController',
            template: registrationWithCardTemplate,
            controllerAs: 'ctrl',
            locals: {
              $state, $rootScope, $q, currentClassRoom, access, classRooms, ProximityCardService, StudentService
            }
          }).finally(() => {
            $state.go('modules.dashboard');
          });
        }
      ]})
    .state('modules.dashboard.unregisterWithCard', {
      url: '/unregisterWithCard',
      onEnter: [
        '$mdDialog',
        '$state',
        '$q',
        '$rootScope',
        'access',
        'ProximityCardService',
        'AttendanceService',
        'CategoryOfDepartureService',
        ($mdDialog, $state, access, ProximityCardService, AttendanceService, CategoryOfDepartureService) => {
          $mdDialog.show({
            clickOutsideToClose: true,
            controller: 'DeregistrationWithCardController',
            template: deregistrationWithCardTemplate,
            controllerAs: 'ctrl',
            locals: {
              access, ProximityCardService, AttendanceService, CategoryOfDepartureService
            }
          }).finally(() => {
            $state.go('modules.dashboard');
          });
        }
      ]
    });
}
